import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { Toast } from './layout/Toast/Toast';
import { useToastStore } from './stores/toastStore';
import { usePortalEvents } from './hooks/usePortalEvents';
import { usePortalResumeRecovery } from './hooks/usePortalResumeRecovery';
import { useRecordEncaissement } from './hooks/useRecordEncaissement';
import { useScrollbarWidthVar } from './hooks/useScrollbarWidthVar';
import { ReconnectingOverlay } from './layout/ReconnectingOverlay/ReconnectingOverlay';

export const App: React.FC = () => {
    const { toasts, dismissToast } = useToastStore();
    usePortalEvents();
    usePortalResumeRecovery();
    // At the shell rather than a page: the receipt is saved in another window, so the operator may be
    // anywhere in the app when the host reports it.
    useRecordEncaissement();
    useScrollbarWidthVar();

    return (
        <>
            <RouterProvider router={router} />
            <ReconnectingOverlay />
            <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-s items-end">
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        type={toast.type}
                        message={toast.message}
                        onDismiss={() => dismissToast(toast.id)}
                    />
                ))}
            </div>
        </>
    );
};
